import { CatalogAllItemsInCityResponse, CatalogItemListRequest, CatalogItemListResponse } from '@common/model/catalog/item/list.request';
import {
  CatalogItemCareerTagCloudsResponse,
  CatalogItemCountingsForCareerLinkingRequest,
  CatalogItemCountingsForCareerLinkingResponseItem,
  CatalogItemCountingsForCityLinkingRequest,
  CatalogItemCountingsForCityLinkingResponseItem,
} from '@common/model/catalog/item/countings.request';
import { CatalogMapCatalogItemsRequest } from '@common/model/catalog/map/map.request';
import { CityCatalogStatsResponse } from '@common/model/catalog/item/cityStatsRequest';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { CatalogMapCatalogItemViewModel } from '@common/model/catalog/item/map.view';
import { coreApi } from '@cp/shared/api/core';
import { CatalogAllItemsInCityRequest } from '@common/model/catalog/item/allItemsInCity.request';
import { CoreCatalogApiTags, coreCatalogApiTagTypes } from './tags';

export const coreCatalogApi = coreApi.enhanceEndpoints({ addTagTypes: coreCatalogApiTagTypes }).injectEndpoints({
  endpoints: (builder) => ({
    getItems: builder.query<CatalogItemListResponse, CatalogItemListRequest>({
      query: (params) => ({
        url: 'catalog/items',
        params,
      }),
      providesTags: (_result, _error, { type, careerId, cityId, page, filter }) => [
        { type: CoreCatalogApiTags.CatalogItemList, id: [type, careerId, cityId, page, JSON.stringify(filter)].join('|') },
      ],
    }),

    getAllItemsInCity: builder.query<CatalogAllItemsInCityResponse, CatalogAllItemsInCityRequest>({
      query: (params) => ({
        url: 'catalog/all-items-in-city',
        params,
      }),
    }),

    getMapCatalogItems: builder.query<CatalogMapCatalogItemViewModel[], CatalogMapCatalogItemsRequest>({
      query: (params) => ({
        url: 'catalog/map/catalog-items',
        params,
      }),
      providesTags: (_result, _error, { type, careerId }) => [
        { type: CoreCatalogApiTags.CatalogMapCatalogItemList, id: [type, careerId].join('|') },
      ],
    }),

    getItemsCityStats: builder.query<CityCatalogStatsResponse, { cityId?: ApiServerEntityIDType }>({
      query: ({ cityId }) => ({
        url: `catalog/items/city-stats/${cityId || ''}`,
      }),
    }),

    getItemsCountingForCareerLinking: builder.query<
      CatalogItemCountingsForCareerLinkingResponseItem[],
      CatalogItemCountingsForCareerLinkingRequest
    >({
      query: (params) => ({
        method: 'POST',
        url: 'catalog/items/countings-for-career-linking',
        body: params,
      }),
    }),

    getItemsCountingForCityLinking: builder.query<
      CatalogItemCountingsForCityLinkingResponseItem[],
      CatalogItemCountingsForCityLinkingRequest
    >({
      query: (params) => ({
        method: 'POST',
        url: 'catalog/items/countings-for-city-linking',
        body: params,
      }),
    }),

    getItemsCareerTagClouds: builder.query<CatalogItemCareerTagCloudsResponse, { cityAlias: string }>({
      query: ({ cityAlias }) => ({
        url: `catalog/items/career-tag-clouds/${cityAlias}`,
      }),
      providesTags: (_result, _error, { cityAlias }) => [{ type: CoreCatalogApiTags.CareerTagClouds, id: cityAlias }],
    }),
  }),
});
